import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
//Images
import athlete from "../img/Thumb.png";
import theracer from "../img/travel.png";
import goodtimes from "../img/medkit1.png";
//Animations
import { motion } from "framer-motion";
import {
  sliderContainer,
  slider,
  pageAnimation,
  fade,
  photoAnim,
  lineAnim,
} from "../animation";
import { useScroll } from "../components/useScroll";
import ScrollTop from "../components/ScrollTop";

const OurWork = () => {
  const [element, controls] = useScroll();
  const [element2, controls2] = useScroll();
  return (
    <Work
      style={{ background: "#080000" }}
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <motion.div variants={sliderContainer}>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
      </motion.div>
      <Movie>
        <motion.h2 style={{ color: "white" }} variants={fade}>
          Apartment Cardinal
        </motion.h2>
        <a href="https://apartment-cardinal.web.app" target="_blank">
          <motion.button style={{ color: "white" }}>Preview</motion.button>
        </a>
        <br />
        <a
          href="https://github.com/ahmedtowsikzap/apartment-cardinal-full-stack"
          target="_blank"
        >
          <motion.button style={{ color: "white" }}>Client Side</motion.button>
        </a>
        <a
          href="https://github.com/ahmedtowsikzap/apartment-cardinal-serverside"
          target="_blank"
        >
          <motion.button style={{ color: "white" }}>Server Side</motion.button>
        </a>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/the-athlete">
          <Hide>
            <motion.img variants={photoAnim} src={athlete} alt="athlete" />
          </Hide>
        </Link>
      </Movie>

      <Movie ref={element} variants={fade} animate={controls} initial="hidden">
        <h2 style={{ color: "white" }}>Travel Cruise</h2>
        <a href="https://travels-cruises.web.app/" target="_blank">
          <motion.button style={{ color: "white" }}>Preview</motion.button>
        </a>
        <br />
        <a
          href="https://github.com/ahmedtowsikzap/Travel-Cruise-serverside-backend.git"
          target="_blank"
        >
          <motion.button style={{ color: "white" }}>Server Side</motion.button>
        </a>
        <a
          href="https://github.com/ahmedtowsikzap/Travel-Cruise-Clientside"
          target="_blank"
        >
          <motion.button style={{ color: "white" }}>Client Side</motion.button>
        </a>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/the-racer">
          <img src={theracer} alt="theracer" />
        </Link>
      </Movie>

      <Movie
        ref={element2}
        variants={fade}
        animate={controls2}
        initial="hidden"
      >
        <h2 style={{ color: "white" }}>MedKit</h2>
        <a href="https://medkit-soul.web.app" target="_blank">
          <motion.button style={{ color: "white" }}>Preview</motion.button>
        </a>
        <a href="https://github.com/ahmedtowsikzap/MedKit" target="_blank">
          <motion.button style={{ color: "white" }}>Code Link</motion.button>
        </a>
        <motion.div variants={lineAnim} className="line"></motion.div>
        <Link to="/work/good-times">
          <img src={goodtimes} alt="goodtimes" />
        </Link>
      </Movie>
      <ScrollTop />
    </Work>
  );
};

const Work = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  @media (max-width: 1300px) {
    padding: 2rem 2rem;
  }

  h2 {
    padding: 1rem 0rem;
  }
`;
const Movie = styled(motion.div)`
  padding-bottom: 10rem;

  .line {
    height: 0.5rem;
    background: #23d997;
    margin-bottom: 3rem;
  }
  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }
`;
const Hide = styled.div`
  overflow: hidden;
`;

//Frame Animation
const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 10%;
  width: 100%;
  height: 100vh;
  background: #fffebf;
  z-index: 2;
`;
const Frame2 = styled(Frame1)`
  background: #ff8efb;
`;
const Frame3 = styled(Frame1)`
  background: #8ed2ff;
`;
const Frame4 = styled(Frame1)`
  background: #8effa0;
`;

export default OurWork;
